import React from "react"
import { Helmet } from "react-helmet-async"
import { FacebookProvider, Comments } from "react-facebook-es"

const CommentsFB = () => {
  return (
    <>
      <FacebookProvider appId="766039557487539">
        <Comments
          colorScheme="light"
          href="https://eduardoceballos.com/"
          numPosts="6"
          orderBy="time"
          width="100%"
          lazy="true"
        />
      </FacebookProvider>
      <Helmet>
        <meta property="fb:app_id" content="766039557487539" />
      </Helmet>
    </>
  )
}

export default CommentsFB
